<template>
    <textarea v-if="this.dom == 'textarea'"
              :ref="this.ident"
              :id="this.ident"
              :name="this.ident"
              :class="this.defaultClass"
              :required="this.isRequired"
              v-model="value">
    </textarea>

    <input v-else
           :ref="this.ident"
           :id="this.ident"
           :name="this.ident"
           :type="this.type ? this.type : 'text'"
           :max="this.type == 'number' ? 2147483647 : ''"
           :class="this.defaultClass"
           :placeholder="this.defaultPlaceholder"
           :required="this.isRequired"
           v-model="value"
           @input="checkLength">
</template>

<script>
    export default {
        name: "autosave-input",

        props: {
            dom: String,
            ident: String,
            isRequired: Boolean,
            type: String,
            defaultValue: String,
            defaultClass: String,
            defaultPlaceholder: String,
            route: String,
            maxLengthCheck: {
                type: Boolean,
                default: false
            },
        },

        data: function () {
            return {
                value: null,
                timeout: null,
            }
        },

        created: function () {
            this.value = this.defaultValue
        },

        mounted: function () {
            this.$refs[this.ident].addEventListener('input', this.listener);
            if (this.maxLengthCheck) {
                this.$refs[this.ident].addEventListener('input', this.checkLength);
            }
        },

        beforeDestroy() {
            if (this.maxLengthCheck) {
                this.$refs[this.ident].removeEventListener('input', this.checkLength);
            }
        },


        methods: {
            listener: function () {
                let parent = this.$refs[this.ident].parentElement
                let target = this.route
                let data = this.postData

                if (this.timeout) {
                    clearTimeout(this.timeout)
                    this.timeout = null
                    parent.classList.remove("loading-spinner")
                }

                parent.classList.remove("error")
                parent.classList.remove("saved")
                parent.classList.add("loading-spinner");
                this.timeout = setTimeout(function () {
                    let axios = require('axios');

                    let config = {
                        method: 'post',
                        url: target,
                        data: data,
                        headers: { }
                    };

                    axios(config)
                        .then(function (response) {
                            parent.classList.remove("loading-spinner")
                            parent.classList.add("saved")
                        })
                        .catch(function (error) {
                            parent.classList.remove("loading-spinner")
                            parent.classList.add("error")
                        });
                }, 2000)
            },
            checkLength() {
                if (!this.maxLengthCheck) return; // If maxLengthCheck is false, do nothing

                if (this.value.length > 50) {
                    alert("Dosáhli jste maximální délky 50 znaků");
                    this.value = this.value.slice(0, 50);
                }
            }
        },

        computed: {
            postData: function () {
                return {
                    name: this.ident,
                    value: this.value
                }
            }
        }
    }
</script>
